import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import { aiModelsAndLabelsApiService } from 'src/services';

export const useModelsLabelsStore = defineStore('model_labels', {
  state: () => ({
    label_count: {} as dynamicObj,
    model_list: [] as any,
  }),
  getters: {
    getLableCountForModel: (state: any) => (model_name: string) => {
      return String(state.label_count[model_name]);
    },
  },
  actions: {
    setLabelsForModels(model_name: string, count = 0) {
      this.label_count[model_name] = count;
    },

    async getModels() {
      const response = await aiModelsAndLabelsApiService.getModels();
      if (response.success === false) {
        throw { message: response.message };
      }
      this.setModelList(response);
    },

    setModelList(response: any) {
      this.model_list = [] as any;
      for (const [index, item] of Object.entries(response)) {
        const row = item as dynamicObj;
        this.setLabelsForModels(row['model_name'], 0);
        this.model_list.push(row);
      }
    },
  },
});
